import { calculateWirtschaftlichkeit } from './calculateWirtschaftlichkeit';
import { IDs } from '../../../helpers/IDs';
import * as Moment from 'moment';

export function calculatePV(
    data: any, params: any, modell: string, ausrichtung: string, neigung: number, groesse: number, stromverbrauch_eingabe: number,
    dachflaeche_eingabe: number, inbetriebnahme_eingabe: Date, isExpert: boolean, investitionskosten_eingabe?: number
) {
    // HIER AUS EINGABE
    /*const modell = 'g1';
    const ausrichtung = 'west30';
    const groesse = 10;
    const stromverbrauch_eingabe = 5000;
    */
    const jahr: number = inbetriebnahme_eingabe.getFullYear();
    // HIER AUS EINGABE ENDE
    // PARAMETER ODER EINGABE
    const amortisation = 8; // Jahre
    const param_i0: number = getParameter(data, jahr, 'I0');
    const param_p: number = getParameter(data, jahr, 'p');
    const stromverbrauch: number = +stromverbrauch_eingabe / 1000;
    const last_erzeugung: any[] = data[IDs.ENT_ERZEUGUNGS_LASTDATEN] || [];
    const start: number = new Date().getTime();
    const monate: any[] = [];
    const summen: any = { realer_verbrauch: 0, reale_erzeugung: 0, diff: 0, diff_nicht_negativ: 0 };
    // console.log('Modell: ', ausrichtung, neigung);
    last_erzeugung.forEach((row: any) => {
        const zeit: number = row.zeit || null;

        // if (Moment(zeit, 'X').year() !== jahr) {
        //    return;
        // }
        const erzeugung: number = row[ausrichtung + neigung] || 0;
        const verbrauch: number = row[modell] || 0;
        const erzeugung_real: number = erzeugung * +groesse;
        const verbrauch_real: number = stromverbrauch * verbrauch;
        const monat: number = Moment(zeit, 'X').month();
        const diff: number = verbrauch_real - erzeugung_real;
        const diff_nicht_negativ: number = diff > 0 ? diff : 0;
        if (!monate[monat]) {
            monate[monat] = { realer_verbrauch: 0, reale_erzeugung: 0, diff: 0, diff_nicht_negativ: 0 };
        }
        monate[monat].realer_verbrauch += verbrauch_real;
        monate[monat].reale_erzeugung += erzeugung_real;
        monate[monat].diff += diff;
        monate[monat].diff_nicht_negativ += diff_nicht_negativ;
    });
    // console.log('MONATE', monate);
    (monate || []).forEach((data: any, monat: number) => {
        monate[monat].selbstverbrauch = data.realer_verbrauch - data.diff_nicht_negativ;
        monate[monat].netzbezug = data.diff_nicht_negativ;
        summen.realer_verbrauch += data.realer_verbrauch;
        summen.reale_erzeugung += data.reale_erzeugung;
        summen.diff += data.diff;
        summen.diff_nicht_negativ += data.diff_nicht_negativ;
    });
    const pv_selbst_verbraucht: number = summen.realer_verbrauch - summen.diff_nicht_negativ;
    const pv_eingespeist: number = summen.reale_erzeugung - pv_selbst_verbraucht;
    const eigenverbrauchs_anteil: number = pv_selbst_verbraucht / summen.reale_erzeugung;
    const autarkiegrad: number = +stromverbrauch_eingabe !== 0 ? pv_selbst_verbraucht / +stromverbrauch_eingabe : 0;
//    const pv_installierte_leistung: number = getLeistungProDachflaeche(data);
    const pv_installierte_leistung: number = +params.pv_faktor_leistung || 5; // {8} fixer Testwert
    const anlagengroesse: number = groesse; //+dachflaeche_eingabe !== 0 ? +dachflaeche_eingabe / pv_installierte_leistung : 0;
    const dachflaeche: number = +groesse * pv_installierte_leistung;
    const ertrag: number = +groesse !== 0 ? summen.reale_erzeugung / +groesse : 0;
    const Ipv: number = param_i0 * Math.pow(+groesse, param_p * -1) * +groesse;
    const spez: number = Ipv / 100;
    const investitions_kosten: number = (typeof investitionskosten_eingabe !== 'undefined'
        ? +investitionskosten_eingabe * +groesse
        : Ipv) + (+groesse >= 30 ? 3000 : 0); // Ab 30 kW 3.000 € Zusatzkosten für die Netzintegration.
    const anlagenkosten: number = +groesse !== 0 ? Ipv / +groesse : 0;
    const end: number = new Date().getTime();
    // console.log('PV:', (end - start), summen);
    // console.log('PV KZ:', pv_selbst_verbraucht, eigenverbrauchs_anteil, autarkiegrad, pv_eingespeist);
    // console.log('PV Param', param_i0, param_p);
    // console.log('PV Erg', Ipv, spez);
    const result = {
        technisch: {
            stromverbrauch: stromverbrauch_eingabe || 0,
            erzeugte_energie: summen.reale_erzeugung,
            netzeinspeisung: pv_eingespeist,
            selbstverbrauch: pv_selbst_verbraucht,
            netzbezug: summen.diff_nicht_negativ,
            eigenverbrauchs_anteil: eigenverbrauchs_anteil * 100,
            autarkiegrad: autarkiegrad * 100,
            anlagengroesse,
            dachflaeche,
            ertrag,
            monate
        },
        wirtschaftlich: {
            investitions_kosten,
            anlagenkosten: typeof investitionskosten_eingabe !== 'undefined' ? investitionskosten_eingabe : anlagenkosten
        }
    };
    calculateWirtschaftlichkeit(params, data, isExpert, result);
    return result;
}

function getLeistungProDachflaeche(data: any): number {
    const hasAnlagen: boolean = (data[IDs.ENT_ANLAGEN_EIGENSTROM] || [])
        .some((element: any) => element.anlagen_eigenstrom_typ_tid_orig === 2); // {2} Photovoltaik

    if (!hasAnlagen) {
        return 0;
    }
    let flaeche: number = 0;
    let leistung: number = 0;

    (data[IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK] || []).forEach((data: any) => {
        flaeche += data.modul_flaeche || 0;
        leistung += data.leistung || 0;
    });

    return flaeche > 0 ? leistung / flaeche : 0;
}

function getParameter(data: any, jahr: number, kennung: string): number {
    let rowFound: any = undefined;
    const parameter: any[] = data[IDs.ENT_PV_PARAMETER] || [];
    // console.log(parameter);
    parameter.filter((row: any) => (row.kennung || null) === kennung).forEach((row: any) => {
        // Wenn wir noch keine Row gefunden haben, nehmen wir die
        if (!rowFound) {
            rowFound = row;
            return;
        }
        // Wir hatten schonmal eine row gefunden
        if (rowFound.jahr > jahr && row.jahr <= jahr) {
            // Diese war größer als das Jahr, wir suchen aber eigentlich das Jahr, das gleich oder kleiner ist
            rowFound = row;
            return;
        }
        // Wir hatten schonmal eine Row, die gleich oder kleiner war
        if (rowFound.jahr < jahr && row.jahr <= jahr && row.jahr > rowFound.jahr) {
            rowFound = row; // Dieses Jahr ist besser
            return;
        }
    });

    if (!rowFound) {
        return -1;
    }

    return rowFound.wert || 0;
}
